import { configProxyApiInstance } from '../config';

const rootPath = `customer-markets`;

export const getMarkets = (config_user_group?: string) =>
  configProxyApiInstance.get(`/${rootPath}`, {
    params: { config_user_group },
  });
